/*
  Unified Fields Props Definition
*/
import {FormattedMessage} from "react-intl"
import React from "react"
import moment from "moment"

export default {
	load() {
		return {
			fields: {
				company: {
					label: <FormattedMessage id="Common.label.company" />,
					type: "string"
				},
				orgunit: {
					label: <FormattedMessage id="Patient.form.patientrequest.orgunit" />,
					rules: "string"
				},
				datefrom: {
					label: <FormattedMessage id="Capitation.List.From" />,
					type: "date",
					rules: "required",
					value: moment().startOf("month")
				},
				dateto: {
					label: <FormattedMessage id="Capitation.List.To" />,
					type: "date",
					rules: "required",
					value: moment().endOf("month")
				},
				identifier: {
					label: <FormattedMessage id="Patient.form.patientinfo.identifier" />,
					type: "string"
				}
			}
		}
	}
}
